export default {
  showNeyaModal(state, value) {
    return (state.showNeyaModal = value);
  },
  allApprovers(state, value) {
    return (state.allApprovers = value);
  },
  approversTotal(state, value) {
    return (state.approversTotal = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  pageApprover(state, value) {
    return (state.pageApprover = value);
  },
  perPageApprover(state, value) {
    return (state.perPageApprover = value);
  },
};
